<template>
  <div class="wrapper">
    <div class="searchconditions">
      <el-form :model="listForm" ref="listForm" label-width="100px" inline>
        <el-form-item prop="batchNum" label="码批次">
          <el-input
            v-model="listForm.batchNum"
            placeholder="请输入批次号"
            maxlength="50"
          ></el-input>
        </el-form-item>
        <el-form-item label="申请时间">
          <el-date-picker
            v-model="searchDate"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="lockFlag" label="下载状态">
          <el-select
            v-model="listForm.companyDownloadStatus"
            clearable
            placeholder="请选择"
          >
            <el-option label="全部" value=""> </el-option>
            <el-option label="未下载" :value="0"> </el-option>
            <el-option label="已下载" :value="1"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="cyan" icon="el-icon-search" @click="searchList"
            >查询</el-button
          >
          <el-button icon="el-icon-refresh" type="warning" @click="reset"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <!-- <el-row :gutter="10">
      <el-col :span="1.5" class="add-btn">
        <el-button
          type="primary"
          icon="el-icon-plus"
          @click="isShow = true"
          :disabled="isApply"
          >申请追溯码</el-button
        >
      </el-col>
    </el-row> -->
    <el-table
      :data="traceCodeList"
      border
      style="width: 100%"
      :cell-style="changeCellStyle"
      v-loading="loading"
    >
      <el-table-column
        type="index"
        label="序号"
        width="80"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="batchNum"
        label="码批次"
        align="center"
        min-width="100"
      >
      </el-table-column>
      <el-table-column
        prop="codeCount"
        label="数量（个）"
        align="center"
        min-width="100"
      ></el-table-column>
      <el-table-column
        prop="generateRule"
        label="码类型"
        align="center"
        min-width="100"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.generateRule == '1'">外码</span>
          <span v-if="scope.row.generateRule == '2'">外码和内码</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="applyTime"
        label="申请时间"
        align="center"
        min-width="130"
      >
      </el-table-column>
      <el-table-column
        prop="downLoadCount"
        label="下载次数"
        align="center"
        min-width="100"
      >
      </el-table-column>
      <el-table-column
        prop="lastDownloadTime"
        label="下载时间"
        align="center"
        min-width="130"
      >
      </el-table-column>
      <el-table-column
        prop="applyUserName"
        label="申请人"
        align="center"
        min-width="100"
      >
      </el-table-column>
      <el-table-column
        prop="organizationName"
        label="所属机构"
        align="center"
        min-width="100"
      >
      </el-table-column>
      <!-- <el-table-column floa="right" label="操作" min-width="100" align="center">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            icon="el-icon-download"
            @click="operationBtn(scope.row)"
            v-if="
              scope.row.status == 3 ||
                scope.row.status == 4 ||
                scope.row.status == 5 ||
                scope.row.status == 6
            "
            >下载</el-button
          >
        </template>
      </el-table-column> -->
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next, sizes, total, jumper"
      :page-sizes="[10, 15, 20]"
      :page-size="listForm.pageSize"
      :total="total"
      :current-page="listForm.pageNum"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    ></el-pagination>
    <!-- <el-dialog
      title="申请追溯码"
      :visible.sync="isShow"
      :close-on-click-modal="false"
      width="700px"
      @close="handleAddClose"
    >
      <el-form
        @submit.native.prevent
        :model="addForm"
        :rules="rules"
        ref="addForm"
        label-width="150px"
      >
        <el-row>
          <el-col :span="16">
            <el-form-item prop="codeCount" label="申请数量：">
              <el-input
                v-model="addForm.codeCount"
                class="codeCount"
                maxlength="7"
                @keyup.native="number"
                @blur="loseInput"
              ></el-input> </el-form-item
          ></el-col>
        </el-row>
        <el-row>
          <el-col :span="16">
            <el-form-item prop="generateRule" label="码类型：">
              <el-radio-group v-model="addForm.generateRule">
                <el-radio label="1">仅外码</el-radio>
                <el-radio label="2">外码和内码</el-radio>
              </el-radio-group>
            </el-form-item></el-col
          >
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button @click="isShow = false">取 消</el-button>
        <el-button type="primary" @click="saveTrace('addForm')">确定</el-button>
      </div>
    </el-dialog> -->
  </div>
</template>

<script>
import {
  saveTracecodeApply1,
  saveTracecodeApply2,
  queryTracecodeList,
  updateTracecodeApplyStatus,
} from "@/common/api.js";
export default {
  components: {},
  props: {},
  data() {
    return {
      loading: false,
      listForm: {
        pageSize: 10,
        pageNum: 1,
        batchNum: "",
        companyDownloadStatus: "",
        startDate: "",
        endDate: ""
      },
      searchDate: null,
      isApply: false,
      addForm: {
        generateRule: "2",
        checkType: "",
        codeLevel: 1, //申请码类型
        codeCount: "", //数量
        remark: "", // 备注
        productId: "", //产品ID
        tagRules: "", //标签规格
        isNeedProduct: 0, //是否选择产品
        relevanceType: "2", //关联类型
        printType: "", //印刷方式
        priority: "", // 优先级
        expectDateFormat: "2021-03-08" // 期望交付日期
      },
      rules: {
        // checkType: [
        //   { required: true, message: "请选择国际码标识", trigger: "change" },
        // ],
        generateRule: [
          { required: true, message: "请选择码类型", trigger: "change" }
        ],
        codeCount: [
          {
            required: true,
            validator: this.validatecodeCount,
            trigger: "blur"
          }
        ]
      },
      traceCodeList: [],
      isShow: false,
      applyId: "",
      total: 0
    };
  },
  watch: {},
  computed: {},
  methods: {
    number() {
      this.addForm.codeCount = this.addForm.codeCount.replace(/[^\.\d]/g, "");
      this.addForm.codeCount = this.addForm.codeCount.replace(".", "");
    },
    loseInput() {
      this.addForm.codeCount = this.addForm.codeCount.replace(/[^\.\d]/g, "");
      this.addForm.codeCount = this.addForm.codeCount.replace(".", "");
    },
    validatecodeCount(rule, value, callback) {
      if (value == "") {
        callback("请填写数量");
      } else {
        if (value > 1000000) {
          callback("最大申请码量为1000000");
        }
        callback();
      }
    },
    handleAddClose() {
      this.$nextTick(() => {
        this.$refs["addForm"].resetFields();
      });
    },
    saveTrace(val) {
      console.log(this.addForm);
      this.$refs[val].validate(valid => {
        if (valid) {
          var param1 = this.addForm;
          this.isApply = true;
          console.log(param1);
          saveTracecodeApply1(param1).then(res1 => {
            if (res1.errorCode == 200) {
              var params2 = {
                applyMainId: res1.msg,
                status: 2,
                service: "",
                aduitIdea: "审核通过"
              };
              saveTracecodeApply2(params2).then(res2 => {
                if (res2.errorCode == 200) {
                  this.isShow = false;
                  this.loading = true;
                  setTimeout(() => {
                    this.getPageList();
                    this.isApply = false;
                  }, 2000);
                } else {
                  this.$message.error(res2.msg);
                  this.isApply = false;
                }
              });
            } else {
              this.$message.error(res1.msg);
              this.isApply = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    operationBtn(row) {
      var status = row.status;
      var id = row.applyId;
      var fileUrl = row.fileUrl;
      // 下载
      if (status == 3 || status == 4 || status == 5 || status == 6) {
        var params = {
          applyId: id,
          companyDownloadStatus: 1
        };
        updateTracecodeApplyStatus(params).then(res => {
          if (res.errorCode == 200) {
            this.DownLoad(fileUrl);
            this.getPageList();
          }
        });
      }
    },
    DownLoad(url) {
      if (window.navigator.msSaveBlob) {
        //IE浏览器
        window.location.href = url;
      } else {
        // 谷歌浏览器 创建a标签 添加download属性下载
        let downloadElement = document.createElement("a");
        downloadElement.href = url;
        downloadElement.target = "_blank";
        downloadElement.download = ""; // 下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); // 点击下载
        document.body.removeChild(downloadElement); // 下载完成移除元素
      }
    },
    searchList() {
      if (this.searchDate) {
        this.listForm.startDate = this.formDate(this.searchDate[0]);
        this.listForm.endDate = this.formDate(this.searchDate[1]);
      } else {
        this.listForm.startDate = "";
        this.listForm.endDate = "";
      }
      this.listForm.pageNum = 1;
      this.getPageList();
    },
    formDate(fromdate) {
      if (fromdate != null) {
        var date = new Date(fromdate);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? "0" + m : m;
        var d = date.getDate();
        d = d < 10 ? "0" + d : d;
        return y + "-" + m + "-" + d;
      }
    },
    changeCellStyle(row, column, rowIndex, columnIndex) {
      if (row.column.label === "批次码" || row.column.label == "操作") {
        return "color: #62a8ea; cursor: pointer;"; // 修改的样式
      }
    },
    handleCurrentChange(cpage) {
      this.listForm.pageNum = cpage;
      this.getPageList();
    },
    handleSizeChange(psize) {
      this.listForm.pageSize = psize;
      this.getPageList();
    },
    getPageList() {
      var params = this.listForm;
      this.loading = true;
      queryTracecodeList(params).then(res => {
        this.loading = false;
        if (res.errorCode == 200) {
          this.traceCodeList = res.data.list;
          this.total = res.data.total;
        }
      });
    },
    // 搜索框重置
    reset() {
      this.$nextTick(() => {
        this.listForm = {
          pageSize: 10,
          pageNum: 1,
          batchNum: "",
          companyDownloadStatus: "",
          startDate: "",
          endDate: ""
        };
        this.$refs["listForm"].resetFields();
        this.searchDate = null;
        this.getPageList();
      });
    }
  },
  created() {
    // this.isMain = window.sessionStorage.getItem("isMain");
  },
  mounted() {
    this.getPageList();
  },
  filters: {
    tagRules(value) {
      switch (value) {
        case 1:
          return "小标";
          break;
        case 2:
          return "中标";
          break;
        case 3:
          return "大标";
          break;
      }
    },
    priority(value) {
      switch (value) {
        case 1:
          return "紧急";
          break;
        case 2:
          return "正常";
          break;
        case 3:
          return "暂缓";
          break;
      }
    },
    status(value) {
      switch (value) {
        case 0:
          return "";
          break;
        case 1:
          return "已提交";
          break;
        case 2:
          return "已审核";
          break;
        case 3:
          return "已生成";
          break;
        case 4:
          return "已确认";
          break;
        case 5:
          return "已印制";
          break;
        case 6:
          return "已激活";
          break;
        case 99:
          return "退回";
          break;
      }
    },
    // operation(row) {
    //   var status = row.status;
    //   if (status == 3 || status == 4 || status == 5 || status == 6) {
    //     return "下载";
    //   }
    // },
    newoperation(row) {
      var status = row.status;
      var printType = row.printType;
      var serviceDownloadStatus = row.serviceDownloadStatus;
      var companyDownloadStatus = row.companyDownloadStatus;
      if (
        ((status == 5 || status == 6) &&
          serviceDownloadStatus == 1 &&
          companyDownloadStatus == 1) ||
        ((status == 3 || status == 4 || status == 5 || status == 6) &&
          companyDownloadStatus == 1)
      ) {
        return "下载";
      }
      // if (
      //   ((status == 5 || status == 6) &&
      //     serviceDownloadStatus == 1 &&
      //     companyDownloadStatus == 1 &&
      //     printType == 2) ||
      //   (printType == 1 &&
      //     (status == 3 || status == 4 || status == 5 || status == 6) &&
      //     companyDownloadStatus == 1)
      // ) {
      //   return "下载";
      // }
    }
  }
};
</script>
<style lang="less" scoped>
.wrapper {
  .searchconditions {
    width: calc(100% - 30px);
    background: #fff;
    border-radius: 6px;
    margin-top: 10px;
    padding: 20px 15px;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);

    .el-form {
      .el-form-item {
        display: inline-block;
        margin-right: 10px;
        vertical-align: top;
        margin: 5px 15px 5px 0px;

        /deep/.el-button {
          padding: 8px 15px;
          font-size: 12px;
          border-radius: 3px;
        }
      }
    }
  }

  // /deep/.el-input__inner,
  // /deep/.searchconditions .el-form-item__content {
  //   height: 34px;
  //   line-height: 34px;
  // }
  // /deep/.el-input__icon,
  // /deep/.el-form-item__label {
  //   line-height: 34px;
  // }
  .el-row {
    margin: 10px 0 0 !important;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    background-color: #ffffff;
    padding: 5px 15px 0;

    .el-select {
      width: 100%;
    }

    .add-btn {
      float: left;
      padding: 0;
      margin-top: 5px;
      margin-bottom: 10px;

      .el-button {
        padding: 8px 15px;
        font-size: 12px;
        border-radius: 3px;
      }
    }
  }

  .code-detail .el-form-item {
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/user/traceCode/traceCode.vue